import { Fireworks } from 'fireworks-js'

export const launchFireworks = async (duration = 3) => {
  let wrapper: HTMLElement | null = document.getElementById('fireworks')
  if (!wrapper) {
    wrapper = document.createElement('div')
    wrapper.id = 'fireworks'
    wrapper.style.position = 'fixed'
    wrapper.style.bottom = '0'
    wrapper.style.left = '0'
    wrapper.style.width = '100%'
    wrapper.style.height = '80vh'
    wrapper.style.zIndex = '999'
    wrapper.style.pointerEvents = 'none'
    wrapper.style.opacity = '1'
    wrapper.style.pointerEvents = 'none'
    document.body.appendChild(wrapper)
  }
  const fireworks = new Fireworks(wrapper, {
    intensity: 40
  })
  fireworks.start()
  await new Promise((resolve) => setTimeout(resolve, 1000 * duration))
  await fireworks.waitStop()
  await wrapper.animate(
    {
      opacity: 0
    },
    { duration: 1500, easing: 'ease-in-out' }
  ).finished
  wrapper.remove()
}
